import { ErrorResponse, fetchAPI } from '@quickbit/backoffice-core-frontend';
import type { MoneyScaled } from '@quickbit/qb-design-system';
import { useQuery } from '@tanstack/react-query';
import {
  CorporateWalletTransactionMinimal,
  NewCorporateWalletTransaction,
} from './walletApi.types';

const queryKeys = {
  all: () => ['wallet'] as const,
  corporateWalletTransactions: (merchantId: string) =>
    [...queryKeys.all(), 'corporate-wallet-transactions', merchantId] as const,
  transactionDetails: (merchantId: string, transactionId: string) =>
    [
      ...queryKeys.all(),
      'transaction-details',
      merchantId,
      transactionId,
    ] as const,
};

export const useGetCorporateWalletTransactions = (merchantId: string) => {
  return useQuery<
    {
      transactions: CorporateWalletTransactionMinimal[];
      balances: Record<string, Record<string, MoneyScaled>>;
      addresses: Record<string, string>;
    },
    ErrorResponse
  >({
    queryKey: queryKeys.corporateWalletTransactions(merchantId),
    queryFn: async () => {
      return await fetchAPI(
        `v1/merchants/${merchantId}/corporate-wallet-transactions`
      );
    },
  });
};

export const useGetTransactionDetails = (
  merchantId: string,
  transactionId: string
) => {
  return useQuery<NewCorporateWalletTransaction, ErrorResponse>({
    queryKey: queryKeys.transactionDetails(merchantId, transactionId),
    queryFn: async () => {
      const transaction = await fetchAPI<NewCorporateWalletTransaction>(
        `v1/merchants/${merchantId}/corporate-wallet-transactions/${transactionId}`
      );

      return {
        ...transaction,
        createdAt: new Date(transaction.createdAt),
      };
    },
  });
};
